import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfterSlider = ({ before, after, title, blurb, dark = false, testid = "before-after-slider-container" }) => {
    const ref = useRef(null);
    const [pos, setPos] = useState(50);
    const [dragging, setDragging] = useState(false);

    const setFromClientX = (clientX) => {
        const rect = ref.current?.getBoundingClientRect();
        if (!rect) return;
        setPos(Math.min(96, Math.max(4, ((clientX - rect.left) / rect.width) * 100)));
    };

    return (
        <figure className="w-full">
            <div
                ref={ref}
                data-testid={testid}
                className="photo-frame relative aspect-[4/3] w-full cursor-ew-resize touch-none select-none overflow-hidden rounded-2xl border border-forest/15"
                onPointerDown={(e) => {
                    setDragging(true);
                    e.currentTarget.setPointerCapture(e.pointerId);
                    setFromClientX(e.clientX);
                }}
                onPointerMove={(e) => dragging && setFromClientX(e.clientX)}
                onPointerUp={() => setDragging(false)}
                onPointerCancel={() => setDragging(false)}
            >
                <img src={after} alt={`${title} — after`} draggable={false}
                    className="absolute inset-0 h-full w-full object-cover" />
                <img src={before} alt={`${title} — before`} draggable={false}
                    className="absolute inset-0 h-full w-full object-cover"
                    style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} />
                <span data-testid={`${testid}-before-label`}
                    className="absolute left-4 top-4 rounded-full bg-forest-night/70 px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-bone backdrop-blur-sm">
                    Before
                </span>
                <span data-testid={`${testid}-after-label`}
                    className="absolute right-4 top-4 rounded-full bg-ochre px-3 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-forest-night">
                    After
                </span>
                <div className="absolute inset-y-0 z-10" style={{ left: `${pos}%` }}>
                    <div className="absolute inset-y-0 -translate-x-1/2 border-l-2 border-bone/90" />
                    <div className="absolute top-1/2 flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-forest/20 bg-bone text-forest shadow-lg">
                        <MoveHorizontal size={16} />
                    </div>
                </div>
            </div>
            <figcaption className="mt-4">
                <p className={`font-display text-lg font-semibold ${dark ? "text-bone" : "text-ink"}`}>{title}</p>
                {blurb && <p className={`mt-1 text-sm ${dark ? "text-bone/60" : "text-moss"}`}>{blurb}</p>}
            </figcaption>
        </figure>
    );
};
